import React from "react";
import AsyncODataDropdownField from "../../Fields/DropdownFields/AsyncODataDropdownField/AsyncODataDropdownField";
import { PdfTemplateDesignerModule } from "./usePdfTemplateDesigner";
import { usePdfTemplatePreviewToolbar } from "./usePdfTemplatePreviewToolbar";
import { Predicate } from "@syncfusion/ej2-data";

export interface PdfTemplateDesignerPreviewToolbarProps {
  baseODataUrl?: string;
  oDataKey?: string;
  getAuthRequestHeader?: () => Promise<Record<string, string> | undefined>;
  templateDesignerModule?: PdfTemplateDesignerModule;
  getTemplateFieldsData?: (
    formId?: string
  ) => Promise<Record<string, string> | {}>;
}

export const PdfTemplateDesignerPreviewToolbar: React.FC<
  PdfTemplateDesignerPreviewToolbarProps
> = ({
  baseODataUrl,
  oDataKey,
  getAuthRequestHeader,
  templateDesignerModule,
  getTemplateFieldsData,
}) => {
  const [ready, setReady] = React.useState<boolean>(false);

  // Use the new preview toolbar hook
  const previewToolbarModule = usePdfTemplatePreviewToolbar(
    templateDesignerModule?.setPreviewMode || (() => Promise.resolve()),
    getTemplateFieldsData
  );

  // Setup
  React.useEffect(() => {
    setup();
  }, []);

  const setup = async () => {
    try {
      await previewToolbarModule.setup();
      setReady(true);
    } catch (error) {
      console.error("Failed to setup preview toolbar:", error);
      setReady(false);
    }
  };

  return (
    <div className="preview-toolbar">
      {ready && (baseODataUrl || oDataKey || getAuthRequestHeader) && (
        <div className="search-expressions-input-container">
          <AsyncODataDropdownField
            type="AsyncODataDropdown"
            value={undefined}
            baseODataUrl={baseODataUrl}
            oDataKey={oDataKey}
            getAuthRequestHeader={
              getAuthRequestHeader || (() => Promise.resolve(undefined))
            }
            textColumnName="label"
            valueColumnName="value"
            searchByPredicateFactory={(searchText: string) => {
              return new Predicate("label", "contains", searchText);
            }}
            placeholder="Search"
            onSubmit={previewToolbarModule.handleChange}
          />
        </div>
      )}
      {ready &&
        !baseODataUrl &&
        !oDataKey &&
        !getAuthRequestHeader &&
        getTemplateFieldsData && (
          <div className="search-expressions-input-container">
            <div className="preview-toolbar-auto-form">Auto Preview Form</div>
          </div>
        )}
    </div>
  );
};
